import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectServicedeskRoute: InvariantJiraRoute = {
	name: 'servicedesk-issues',
	// Remove the issueKey path param when cleaning up slv-4_migrate_nin_selected_issue_route
	path: '/jira/servicedesk/projects/:projectKey/issues/:issueKey?',
	query: ['selectedIssue?'],
};
